import { Bot, Inbox, LayoutDashboard, LogOut, Settings, Users, Zap } from "lucide-react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth, useLogout } from "../hooks/useAuth";

const links = [
  { to: "/dahsbot", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/dahsbot/conversations", label: "Conversazioni", icon: Inbox, end: false },
  { to: "/dahsbot/leads", label: "Lead", icon: Users, end: false },
  { to: "/dahsbot/offerte", label: "Offerte", icon: Zap, end: false },
  { to: "/dahsbot/allowed-topics", label: "Temi consentiti", icon: Settings, end: false },
];

export function AppLayout() {
  const auth = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-200">
        Caricamento...
      </div>
    );
  }

  if (auth.isError) {
    return <Navigate to="/dahsbot/login" replace />;
  }

  const user = auth.data?.user;

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <aside className="fixed inset-y-0 left-0 hidden w-72 border-r border-white/10 bg-slate-900/80 p-6 backdrop-blur lg:block">
        <div className="flex items-center gap-3">
          <div className="rounded-2xl bg-emerald-400 p-3 text-slate-950">
            <Bot className="h-6 w-6" />
          </div>
          <div>
            <p className="text-lg font-semibold">Chatbot AI</p>
            <p className="text-sm text-slate-400">WhatsApp Console</p>
          </div>
        </div>

        <nav className="mt-10 space-y-2">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition ${
                  isActive
                    ? "bg-emerald-400 text-slate-950"
                    : "text-slate-300 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="lg:pl-72">
        <header className="border-b border-white/10 bg-slate-950/80 backdrop-blur">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <p className="text-sm text-slate-400">Azienda</p>
              <h1 className="text-xl font-semibold">{user?.company?.name ?? "Company"}</h1>
            </div>
            <button
              onClick={() => logout.mutate(undefined, { onSuccess: () => navigate("/dahsbot/login") })}
              className="inline-flex items-center gap-2 rounded-xl border border-white/10 px-4 py-2 text-sm text-slate-200 hover:bg-white/10"
            >
              <LogOut className="h-4 w-4" />
              Esci
            </button>
          </div>
          <nav className="flex gap-2 overflow-x-auto px-4 pb-3 lg:hidden">
            {links.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `shrink-0 rounded-xl px-3 py-2 text-sm font-medium ${
                    isActive ? "bg-emerald-400 text-slate-950" : "bg-white/5 text-slate-300"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </header>
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
